import { render, staticRenderFns } from "./PaceConverter.vue?vue&type=template&id=2cd991ea&scoped=true&"
import script from "./PaceConverter.vue?vue&type=script&lang=js&"
export * from "./PaceConverter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd991ea",
  null
  
)

export default component.exports